import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import ActionButton from "@/components/base/ActionButton";
import { processSteps } from "@/mocks/process";

export default function ProcessSection() {
  return (
    <section className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="mx-auto w-full max-w-container px-4 md:px-6">
        <Reveal>
          <SectionHeading
            align="center"
            tone="dark"
            eyebrow="How EV Retrofit Works"
            title="A Structured Six-Step Retrofit Process"
            description="Every retrofit follows an engineering-led path. Specifications and the final configuration are determined only after the technical assessment stage."
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {processSteps.map((item, index) => (
            <Reveal key={item.step} delay={index * 0.07}>
              <article className="relative h-full rounded-lg border border-background-50/[0.12] bg-background-50/[0.04] p-6 transition-colors duration-300 hover:border-primary-400/50">
                <div className="flex items-center justify-between">
                  <span className="font-heading text-3xl font-extrabold text-primary-400">
                    {item.step}
                  </span>
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-background-50/10 text-accent-400">
                    <i className={`${item.icon} text-xl`} />
                  </span>
                </div>
                <h3 className="mt-5 text-base font-semibold text-background-50">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-background-300">
                  {item.description}
                </p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-12 flex flex-col items-center gap-4 rounded-lg border border-background-50/12 bg-background-50/[0.04] p-6 md:flex-row md:justify-between md:p-8">
            <p className="text-center text-sm leading-relaxed text-background-200 md:text-left">
              Final feasibility, specifications, cost and range are confirmed only after technical
              assessment of the specific vehicle.
            </p>
            <ActionButton to="/ev-retrofit#eligibility" variant="primary" size="md" icon="ri-flashlight-line">
              Start with an Assessment
            </ActionButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
}